import { populate } from 'populate';
import dragonBones from 'pixi-dragonbones';

const raw = {
    className: 'Halloween2022FTUXLayout',
    width: 1351,
    height: 760,
    x: 50,
    y: 50,
    list: [
        {
            id: '35932428-2464-4112-a641-9c7a3c3eabfd',
            type: 'Container',
            name: 'root',
            nameSpace: '',
            className: '',
            x: 8,
            y: 10,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '',
            data: '',
        },
        {
            id: '56d10d43-6dc5-4c15-bf5c-37c2b2d0603e',
            type: 'Sprite',
            name: 'bg',
            nameSpace: '',
            className: '',
            x: -403,
            y: -364,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'UI_halloween_intro_window',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '75d6e23c-4dc5-46f0-8c09-1a0095ae812c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -2,
            y: -310,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'UI_halloween_intro_Tittle',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: 'd0d1b581-3766-4bb7-9760-c13780a84730',
            type: 'Sprite',
            name: 'closeButton',
            nameSpace: '',
            className: '',
            x: 378,
            y: -301,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: true,
            buttonMode: true,
            hitArea: {
                type: 'None',
            },
            texture: 'UI_halloween_intro_X',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '506f8522-4c0d-4791-9989-44d0446fe032',
            type: 'Text',
            name: 'title',
            nameSpace: '',
            className: '',
            x: -1,
            y: -321,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'HalloweenFTUX22',
            localize: true,
            maxWidth: 420,
            maxHeight: 90,
            maxFontSize: 48,
            icons: [],
            style: {
                fontSize: 24,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#FFFFFF',
                stroke: '#3f5d88',
                strokeThickness: 4,
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: -19,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 3,
            },
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '7902442a-3942-4c88-a05d-9850f3a85a99',
            type: 'Text',
            name: 'description',
            nameSpace: '',
            className: '',
            x: -4,
            y: 147,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'HalloweenFTUXDescription22',
            localize: true,
            maxWidth: 722,
            maxHeight: 170,
            maxFontSize: 32,
            icons: [],
            style: {
                fontSize: 24,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#bb3c2f',
                stroke: '#003862',
                strokeThickness: 0,
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 55,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: -19,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 1,
            },
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: 'b0c6cc53-8eb8-4efe-b075-36fe5166c942',
            type: 'Container',
            name: 'labelsContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '603dd4ee-1353-48a0-8082-0c613c2cc792',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 300,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'button_medium_bg',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: 'f8a0b8a8-fc3e-473a-88aa-857b77d40b10',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -362,
            y: -240,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'UI_halloween_intro_Pic',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '25790065-3987-4a6d-956a-a384e6c67fc2',
            type: 'Sprite',
            name: 'Halloween_bottom_left',
            nameSpace: '',
            className: '',
            x: -684,
            y: 370,
            anchor: {
                x: 0,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'Halloween_intro_Charlie',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '11674a13-21d2-49de-b605-ebfcdad360eb',
            type: 'Sprite',
            name: 'Halloween_bottom_right',
            nameSpace: '',
            className: '',
            x: 667,
            y: 370,
            anchor: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'UI_halloween_intro_Pumpkin',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '423bd042-2e26-4bc7-af2f-354ad584c3e6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 325,
            y: 4,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'UI_halloween_intro_Bat_2',
            parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
            data: '',
        },
        {
            id: '30f009e3-f976-4895-a12e-86b73d417435',
            type: 'Sprite',
            name: 'startButton',
            nameSpace: '',
            className: '',
            x: 0,
            y: -3,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1.099656,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: true,
            hitArea: {
                type: 'None',
            },
            texture: 'button_medium_green',
            parent: '603dd4ee-1353-48a0-8082-0c613c2cc792',
            data: '',
        },
        {
            id: 'f3b6207e-e4f2-485d-96bf-5e4182a42825',
            type: 'Text',
            name: 'startButtonText',
            nameSpace: '',
            className: '',
            x: -1,
            y: -3,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'HalloweenFTUXButton22',
            localize: true,
            maxWidth: 200,
            maxHeight: 74,
            maxFontSize: 0,
            icons: [],
            style: {
                fontSize: 45,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#FFFFFF',
                stroke: '#17762E',
                strokeThickness: 6,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'round',
                miterLimit: 10,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: '30f009e3-f976-4895-a12e-86b73d417435',
            data: '',
        },
    ],
    version: '1.0.x',
} as const;

export class Halloween2022FTUXLayout {
    static raw = raw;
    root: PIXI.Container;
    bg: PIXI.Sprite;
    closeButton: PIXI.Sprite;
    title: PIXI.Text;
    description: PIXI.Text;
    labelsContainer: PIXI.Container;
    startButton: PIXI.Sprite;
    startButtonText: PIXI.Text;
    Halloween_bottom_left: PIXI.Sprite;
    Halloween_bottom_right: PIXI.Sprite;

    constructor() {
        populate(this, raw);
    }
}
